import axios from 'axios';

import { getAuthorizationHeader } from '../utils/getAuthHeader';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8081'}`;

const url = `${API_URL}/forms-link`;

export const generateShareableForm = async (
  id,
  idForm,
  expiration,
  selectedLanguage,
  isAnonymous,
  isHidden,
  isMultipleSubmission,
  confirmCreation = false
) => {
  const result = await axios.post(
    `${url}/generate-token`,
    {},
    {
      params: {
        generatedBy: id,
        idForm,
        expiration,
        language: selectedLanguage,
        isAnonymous,
        isHidden,
        isMultipleSubmission,
        confirmCreation,
      },

      headers: getAuthorizationHeader(),
    }
  );
  return result.data;
};

export const updateShareableForm = async (
  id,
  expiration,
  selectedLanguage,
  isAnonymous,
  isHidden,
  isMultipleSubmission
) => {
  const body = {
    expiresOn: expiration,
    language: selectedLanguage,
    isAnonymous,
    isHidden,
    isMultipleSubmission,
  };
  const result = await axios.put(`${url}/update/${id}`, body, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

export const fetchFromLinkById = async (id, token, clientId) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'multipart/form-data',
    'X-Client-ID': clientId,
  };
  const result = await axios.get(`${url}/get-form-link/${id}`, {
    headers,
  });
  return result.data;
};

export const fetchFromLinkVisitsNbrById = async (id) => {
  const result = await axios.get(`${url}/get-form-link_visit-count/${id}`, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

export const fetchFormsSharableByGeneratedBy = async (id) => {
  const result = await axios.get(`${url}/generated-by/${id}`, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

export const fetchAllFormsSharable = async () => {
  const result = await axios.get(`${url}/all`, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

// delete form link
export const deleteFormLink = async (id) => {
  const result = await axios.delete(`${url}/delete/${id}`, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

// delete multiple form links
export const deleteMultipleFormLinks = async (ids) => {
  const queryString = ids.map((id) => `ids=${id}`).join('&');
  const fullUrl = `${url}/delete-multiple?${queryString}`;
  const result = await axios.delete(fullUrl, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

// activate inavtive form link
export const activateFormLink = async (id) => {
  const result = await axios.put(
    `${url}/active-inactive-form-link/${id}`,
    {},
    { headers: getAuthorizationHeader() }
  );
  return result.data;
};

export const fetchFormLinkByToken = async (token) => {
  const result = await axios.get(`${url}/get-form-link-by-token/${token}`, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

export const visitFormLink = async (id, token, clientId) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    'X-Client-ID': clientId,
  };
  const result = await axios.put(
    `${url}/visit-form-link/${id}`,
    {},
    {
      headers,
    }
  );
  return result.data;
};
